module.exports = __webpack_public_path__ + "img/ad_800_96.288133f1.png";